.atm_l8_ftgil2{padding:8px;}
.atm_9s_1txwivl{display:flex;}
.atm_j6_1ylpe5n{min-height:40px;}
.atm_vy_1osqo2v{width:100%;}
.atm_26_1pec9uq{background:#ffffff;}
.atm_h_1h6ojuz.atm_h_1h6ojuz{align-items:center;}
.atm_3f_1fz0aif{border:1px solid #CED3DA;}
.atm_uc_m5lnj1{transition:background 0.2s ease;}
.atm_rd_glywfm{text-decoration:none;}
.atm_7l_6s2ej5{color:#424952;}
.atm_1yykhu7_glywfm:not(:first-child){border-top:none;}
.atm_afzqfr_1j8p9j8:first-child{border-radius:4px 4px 0 0;}
.atm_eoxiwz_1se7qw9:last-child{border-radius:0 0 4px 4px;}
.atm_14krxw6_1y44olf:only-child{border-radius:4px;}
.atm_26_1byrjjm{background:#E7EBEE;}
.atm_9j_73adwj{cursor:default;}
.atm_1y17hwk_118lp2q.atm_1y17hwk_118lp2q:hover{background-color:#F4F5F7;}
.atm_e2_1osqo2v{height:100%;}
.atm_cx_1tcgj5g{gap:24px;}
.atm_h0_exct8b.atm_h0_exct8b{margin-right:16px;}
.atm_gz_1wugsn5.atm_gz_1wugsn5{margin-left:auto;}
.atm_gi_idpfg4{margin:0;}
.atm_ks_15vqwwr{overflow:hidden;}
.atm_sq_1l2sidv{text-overflow:ellipsis;}
.atm_vv_1q9ccgz{white-space:nowrap;}
.atm_k4_1piyxwk{opacity:0.5;}
